import React, { useEffect } from 'react'
import YouTube from 'react-youtube'
//@ts-expect-error
import * as Rutube from 'rutube-player'
import { TVideoType } from 'shared/constants'

export type TReadyTarget = {
  stopVideo: () => void
  pauseVideo: () => void
  playVideo: () => void
}

type Props = {
  type?: TVideoType
  videoId: string
  height?: number
  onReady: (e: { target: TReadyTarget }) => void
  onPlay: () => void
  onPause: () => void
}
export const Video: React.FC<Props> = ({
  type = 'youtube',
  videoId,
  height = 320,
  onReady,
  onPause,
  onPlay,
}) => {
  const opts = {
    height: height.toString(),
    width: '100%',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      showinfo: 0 as const,
      fs: 0 as const,
    },
  }
  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }
    const rt = new Rutube()
    if (type === 'rutube') {
      rt.Player(`player_${videoId}`, {
        ...opts,
        videoId: videoId,
        onReady,
        onPlay,
        onPause,
      })
    }
  }, [])
  if (type === 'rutube') {
    return <div id={`player_${videoId}`}></div>
  }
  return (
    <YouTube
      videoId={videoId}
      opts={opts}
      onReady={onReady}
      onPlay={onPlay}
      onPause={onPause}
    />
  )
}
